import { createStyles } from 'antd-style'

import { TaskType } from './types'

export const useStyles = createStyles(
  ({ token }, { type, priority }: { type: TaskType; priority?: number }) => {
    const taskColors: Record<TaskType, string> = {
      expired: token.colorError,
      current: token.colorInfo,
      future: token.colorSuccess
    }

    const priorityColors: Record<number, string> = {
      1: token.colorError,
      2: token.colorInfo,
      3: token.colorSuccess
    }

    return {
      taskHeader: {
        width: 100,
        minWidth: 100,
        height: 100,
        backgroundColor: taskColors[type],
        borderRadius: 4,
        color: token.colorWhite,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },

      taskHeaderText: {
        color: token.colorWhite,
        fontWeight: 500
      },

      priority: {
        width: 6,
        minWidth: 6,
        height: 20,
        backgroundColor: priority
          ? priorityColors[priority]
          : token.colorSuccess,
        borderTopLeftRadius: 4,
        borderBottomLeftRadius: 4,
        marginLeft: 8
      },

      taskList: {
        padding: '12px 0'
      }
    }
  }
)
